import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, doc, getDocs } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext';
import { PiBooks } from "react-icons/pi";
import { MdAccountCircle, MdManageAccounts, MdSave, MdSearch } from "react-icons/md";
import { Create_ledger_account } from "./Create_ledger_account.js";
import logo_default from "../../assets/logo_default.jpg";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Create_ledger_accounts() {
    const [accounts_name, setAccounts_name] = useState("");
    const [description, setDescription] = useState("");
    const [mobile, setMobile] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [slug, setSlug] = useState("");
const servicetablename = "accountingfinancedb";
    const [account_type, setAccount_type] = useState("");
    const [accountguid, setaccountguid] = useState("");
    const [photoURL, setPhotoURL] = useState("");
    const [accountmobile, setAccountmobile] = useState("");
    const [searchstatus, setSearchstatus] = useState(false);

    const handleCreate = async () => {

        if (!accounts_name || !accounts_name.trim()) {
            Toastshow("Please enter oucher name.");
            return;
        }
        if (!account_type || !account_type.trim()) {
            Toastshow("Please Select role type.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter Description.");
            return;
        }
        const data = {
            name: accounts_name.replaceAll("_", " "),
            accountguid,
            mobile,
            logo_url: photoURL,
            usecase: true,
            slug,
            status: false,
            description: description,
            account_type: account_type.replaceAll(" ", "_").toLowerCase(),
            // Add other necessary fields here
        };
        const result = await Create_ledger_account(data);
        if (result.success) {
            setAccounts_name("");
            setDescription("");
            Toastshow("Voucher saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    const handle_search_accountguid = async (mobile) => {
        const checkQuery = query(
            collection(db, "accounts"),
            where("mobile", "==", mobile)
        );
        const checkSnap = await getDocs(checkQuery);

        if (!checkSnap.empty) {
            setSearchstatus(true);
            // ✅ Existing User: skip creating
            const userDoc = checkSnap.docs[0];
            const userData = userDoc.data();
            setaccountguid(userData.guid);
            setSlug(normalize(normalize(userData.name)));
            setAccounts_name(userData.name);
            setPhotoURL(userData.photoURL);
            setMobile(userData.mobile);
            setDescription(userData.address + ", " + userData.city);
        } else {
            setSearchstatus(false);
        }
    }


    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    return (
        <div >
            <div className="items-back b-1 rounded p-2">
                <table>
                    <tr>
                        <td><div className="text-h2 bold">Create ledger account </div></td>
                    </tr>
                    <tr>
                        <td className="text-h3 text-off">How to get mobile from the account profile</td>
                    </tr>

                    <tr>
                        <td>
                            <table>
                                <tr>
                                    <td>
                                        <img className="icon-photo rounded-circle"
                                            src={photoURL || logo_default}
                                            alt="photo"
                                        />
                                    </td>
                                    <td>

                                        <input type="text" className="p-2" onChange={(e) => {
                                            setaccountguid(e.target.value);

                                            handle_search_accountguid(e.target.value);
                                        }}

                                            maxLength={50} placeholder="Enter mobile number" />
                                    </td>

                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <select
                                value={account_type}
                                onChange={(e) => setAccount_type(e.target.value)}
                                className="text-h2 bold p-2"
                            >
                                <option value="">Select role type</option>

                                {/* Administrative */}
                                <optgroup label="Administrative">
                                    
                                    <option value="office_admin">Office Admin</option>
                                    <option value="super_admin">Senior Manager</option>
                                    <option value="manager">Manager</option>
                                    
                                    <option value="office_team">Office Team</option>
                                    <option value="hr_manager">HR Manager</option>
                                    <option value="hr_executive">HR Executive</option>
                                </optgroup>

                                {/* Operations */}
                                <optgroup label="Operations">
                                    <option value="staff">Staff</option>
                                    <option value="staff_list">Staff List</option>
                                    <option value="team_leader">Team Leader</option>
                                    <option value="field_staff">Field Staff</option>
                                    <option value="delivery_staff">Delivery Staff</option>
                                    <option value="inventory_manager">Inventory Manager</option>
                                    <option value="store_keeper">Store Keeper</option>
                                    <option value="technician">Technician</option>
                                    <option value="support_staff">Support Staff</option>
                                </optgroup>

                                {/* Accounting & Finance */}
                                <optgroup label="Accounting & Finance">
                                    <option value="accountant">Accountant</option>
                                    <option value="cashier">Cashier</option>
                                    <option value="auditor">Auditor</option>
                                    <option value="finance_manager">Finance Manager</option>
                                    <option value="billing_staff">Billing Staff</option>
                                    <option value="bank">Bank</option>
                                </optgroup>

                                {/* Sales & Marketing */}
                                <optgroup label="Sales & Marketing">
                                    <option value="sales_manager">Sales Manager</option>
                                    <option value="sales_executive">Sales Executive</option>
                                    <option value="marketing_manager">Marketing Manager</option>
                                    <option value="marketing_executive">Marketing Executive</option>
                                    <option value="telecaller">Telecaller</option>
                                    <option value="customer_support">Customer Support</option>
                                </optgroup>

                                {/* External Parties */}
                                <optgroup label="External Parties">
                                    <option value="customer">Customer</option>
                                    <option value="supplier">Supplier</option>
                                    <option value="vendor">Vendor</option>
                                    <option value="contractor">Contractor</option>
                                </optgroup>

                            </select>



                        </td>
                    </tr>
                    <tr>
                        <td><input type="text" className="p-2" value={accounts_name} onChange={(e) => {
                            setAccounts_name(e.target.value);
                        }} maxLength={30} placeholder="Enter account name" /></td>
                    </tr>
                    <tr>
                        <td><input type="phone" className="p-2" value={mobile} onChange={(e) => {
                            setMobile(e.target.value);


                        }} maxLength={30} placeholder="Enter Mobile number" /></td>
                    </tr>


                    <tr>
                        <td><div className="text-h2 bold">Description</div></td>
                    </tr>
                    <tr>
                        <td><textarea className="p-2" value={description} onChange={(e) => setDescription(e.target.value)} maxLength={200} placeholder="Enter description" /></td>
                    </tr>
                </table>


                {searchstatus == true ? (
                    <div className="button-ui green-back p-22 fill text-h2    cursor" onClick={() => handleCreate()}><MdSave className="icon" /> {account_type.replaceAll("_", " ")} Create account</div>

                ) : (<div className="button-ui p-22 fill text-h2 fcap  cursor" onClick={() => handle_search_accountguid(accountguid)}><MdSearch className="icon" /> {account_type.replaceAll("_", " ")} Search now</div>)}

            </div>
        </div>
    );
}
